<template>
    <div class="carBox carBoxLeft">
        <div class="newBox">
        <div class="searchBox">

            <div class="searchGroup">
                <label>角色名称：</label>
                <el-input v-model="search_Obj.f_rolename" clearable @keyup.enter.native="doSearch"></el-input>
            </div>
            <div class="searchGroup">
                <label>角色类型：</label>
                <el-select v-model="search_Obj.f_role_type" clearable placeholder="请选择" @keyup.enter.native="doSearch">
                    <el-option v-for="item in enuObj('role_type')" :key="'role_type'+item.key" :label="item.title" :value="item.key"> </el-option>
                </el-select>
            </div>
            <div class="searchGroup">
                <label>技术服务人员：</label>
                <el-select v-model="search_Obj.f_is_jishu" clearable placeholder="请选择" @keyup.enter.native="doSearch">
                    <el-option v-for="item in enuObj('yesNo')" :key="'yesNo'+item.key" :label="item.title" :value="item.key"> </el-option>
                </el-select>
            </div>
            <el-button type="primary" size="medium" icon="el-icon-search" @click.native="doSearch">搜索</el-button>
        </div>
    <el-card class="box-card">
        <div class="mainBody">
        <div class="btnBox">
            <Btns :menu_id="menu_id" :menus="main_btns" @on_btnclk="btnClick"></Btns>
        </div>
            <div class="dataBox">
                                <el-table :data="tableData" :default-sort="sortData" @sort-change="sortChange" @selection-change="selectChanges" v-loading="loading" border stripe>
                                    <el-table-column type="selection" align="center" width="50"></el-table-column>
                                    <el-table-column prop="rolename" label="角色名称" sortable="custom"></el-table-column>
                                    <el-table-column prop="role_type" label="角色类型" sortable="custom">
                                        <template slot-scope="scope">
                                            <span>{{ transEnu(scope.row.role_type, "role_type") }}</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="is_jishu" label="技术服务人员" sortable="custom">
                                        <template slot-scope="scope">
                                            <span>{{ transEnu(scope.row.is_jishu, "yesNo") }}</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="order_index" label="顺序" sortable="custom" width="100"></el-table-column>
                                    <el-table-column label="操作" width="240" align="center">
                                        <template slot-scope="scope">
                                            <LabBtns :menu_id="menu_id" :row="scope.row" :index="scope.$index" :menus="lab_btns" @on_btnclk="labelClick"></LabBtns>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </div>
            <div class="pageBox">
                                <el-pagination background layout="total, sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 50]" :current-page="current" :page-size="pagesize" :total="total" @current-change="pageChange" @size-change="handleSizeChange"></el-pagination>
                            </div>
            <RoleMenu
                                width="1200px"
                                :id="model_id"
                                title="配置权限"
                                :isshow="infoshow"
                                @on-close="closeInfoDialog">
                            </RoleMenu>
        </div>
    </el-card>
</div>
        <Edit
                            width="600px"
                            :id="model_id"
                            :title="edit_title"
                            :isshow="editshow"
                            @on-close="closeEditDialog"
                            @on-save-ok="saveOk">
                        </Edit>
    </div>
</template>

<script>
import Btns from "@/components/common/btns";
import LabBtns from "@/components/common/labbtns";
import Edit from "./edit";
import RoleMenu from "./rolemenu";
import listutil from "@/libs/listutil";
import { copyRole } from "@/api/role";

export default {
    name: "roleList",
    mixins: [listutil],
    components: {Edit, RoleMenu, Btns, LabBtns},
    data() {
        return {
            m_name: '角色',
            menu_id: 1200,
            list_url: "/api/admin/role/list",
            search_Obj: {
                f_rolename: '',
                f_role_type: '',
                f_is_jishu: ''
            },
            del_Obj:{
                url:'/api/admin/role/del',
                data:{
                    ids:''
                }
            },
            sortData: {
                prop: 'order_index',
                order: 'ascending'
            },
            enu_name: ['role_type', 'yesNo'],
        };
    },
    mounted() {},
    methods: {
        jurisdiction(index, row){
            this.model_id = row.id
            this.infoshow = true
        },
        copy() {
            console.log(this.selectData.length)
            if (this.selectData.length <= 0) {
                this.$msg("请选择要复制的角色")
            } else if (this.selectData.length != 1) {
                this.$msg("只能选择一个角色进行复制")
            } else {
                copyRole(this.selectData[0].id).then(res=>{
                    if(res.code == 1){
                        this.$msgs("复制成功")
                        this.getListData();
                    }else{
                        this.$msg(res.msg)
                    }
                })
            }
        },
    }
};
</script>